import * as classnames from 'classnames/bind'
import * as React from 'react'
import AccountCard from '../../components/AccountCard'
import BasicLayout from '../../layouts/BasicLayout'
import styles from './account-page.scss'

const cx = classnames.bind(styles)

class AccountPage extends React.PureComponent {
  public render() {
    return (
      <BasicLayout>
        <div>
          <div className={cx('page-Profile__main')}>
            <div className={cx('container')}>
              <AccountCard />
            </div>
          </div>
        </div>
      </BasicLayout>
    )
  }
}

export default AccountPage



// WEBPACK FOOTER //
// ./src/pages/AccountPage/index.tsx